/**
 * coconsolexTokens.js
 * ---------------------------------------------------------------------------
 * CoConsoleX inherits all base CaseSignalHQ tokens and adds three accents:
 *   - privilege gold (used sparingly on bubbles + trust badges)
 *   - diode green (one-way data-flow arrows only)
 *   - caution amber (unverified-citation flag only)
 */

import { tokens as baseTokens } from "./tokens.js";

export const cxTokens = {
  ...baseTokens,
  cream: "#FAF7F0",
  paper: "#FFFFFF",
  rule: "#C9C2B2",
  slate: "#3D5A80",
  privilegeGold: "#A8862B",
  diodeGreen: "#2F5D3A",
  cautionAmber: "#B8860B",
  navTint: "#F0EDE5",
};

/**
 * Single source of truth for the fifteen CoConsoleX subtabs.
 * Roman numerals match the source brief (I–XV).
 */
export const SUBTABS = [
  { roman: "I", slug: "", title: "Overview", path: "/coconsolex" },
  { roman: "II", slug: "why-it-matters", title: "Why It Matters", path: "/coconsolex/why-it-matters" },
  { roman: "III", slug: "who-it-serves", title: "Who It Serves", path: "/coconsolex/who-it-serves" },
  { roman: "IV", slug: "identity-access", title: "Identity & Access", path: "/coconsolex/identity-access" },
  { roman: "V", slug: "matter-segregation", title: "Matter Segregation", path: "/coconsolex/matter-segregation" },
  { roman: "VI", slug: "litigation-hold", title: "Litigation Hold", path: "/coconsolex/litigation-hold" },
  { roman: "VII", slug: "output-verification", title: "Output Verification", path: "/coconsolex/output-verification" },
  { roman: "VIII", slug: "backup-continuity", title: "Backup & Continuity", path: "/coconsolex/backup-continuity" },
  { roman: "IX", slug: "hardware-lifecycle", title: "Hardware Lifecycle", path: "/coconsolex/hardware-lifecycle" },
  { roman: "X", slug: "insurance-risk", title: "Insurance & Risk", path: "/coconsolex/insurance-risk" },
  { roman: "XI", slug: "audit-examination", title: "Audit & Examination", path: "/coconsolex/audit-examination" },
  { roman: "XII", slug: "cross-border", title: "Cross-Border", path: "/coconsolex/cross-border" },
  { roman: "XIII", slug: "engagement-sunset", title: "Engagement Sunset", path: "/coconsolex/engagement-sunset" },
  { roman: "XIV", slug: "mid-market-equity", title: "Mid-Market Equity", path: "/coconsolex/mid-market-equity" },
  { roman: "XV", slug: "validation-procurement", title: "Validation & Procurement", path: "/coconsolex/validation-procurement" },
];
